@if (loadFailed()) {
  <section role="alert" style="max-width: 800px; margin: 80px auto; padding: 24px;">
    <h1>This page could not finish loading</h1>
    <p>Please reload the page to try again.</p>
    <button type="button" (click)="retryPage()">Reload page</button>
  </section>
} @else if (resolveResult(); as result) {
  @if (componentType(); as ct) {
    <ng-container *ngComponentOutlet="ct; inputs: componentInputs()" />
  }
}
